import type { ResolveScopeName } from "../../../../lib/roleChip";

export type ScopeFilterResult<T> = T & {
  hiddenScopeCount: number;
};

export function filterVisibleScopes<T extends { scopeIds: string[] }>(
  entries: readonly T[],
  scopeKind: string,
  resolveScopeName: ResolveScopeName
): ScopeFilterResult<T>[] {
  return entries
    .map((entry) => {
      const visible: string[] = [];
      let hidden = 0;
      for (const id of entry.scopeIds) {
        if (resolveScopeName(id, scopeKind) != null) {
          visible.push(id);
        } else {
          hidden++;
        }
      }
      return { ...entry, scopeIds: visible, hiddenScopeCount: hidden };
    })
    .filter((entry) => entry.scopeIds.length > 0 || entry.hiddenScopeCount > 0);
}
